import { Suspense } from "react";
import { getGuidelineList } from "../../utils/getConstants";
import { AppLayout, AppSidebar, MainContent } from "../Layout";
import { Link } from "react-router-dom";

const GuidelineMenu = () => {
  return (
    <>
      <Suspense fallback={<div className="loader"></div>}>
        <AppLayout useMainContentWrapper={false} appSidebar={<AppSidebar />}>
          <MainContent padding="default">
            {getGuidelineList().map((guideline) => (
              <div key={guideline.linkText}>
                <Link
                  key={guideline.linkText}
                  to={`/guidelines/${guideline.onClickProps.replaceAll(" ", "_")}`}
                >
                  {guideline.onClickProps}
                </Link>
              </div>
            ))}
          </MainContent>
        </AppLayout>
      </Suspense>
    </>
  );
};

export default GuidelineMenu;
